const CroppedImg = (imageSrc, pixelCrop) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = imageSrc;
    image.crossOrigin = "anonymous";

    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = pixelCrop.width;
      canvas.height = pixelCrop.height;
      const ctx = canvas.getContext("2d");

      ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        pixelCrop.width,
        pixelCrop.height
      );

      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error("Canvas is empty"));
          return;
        }
        
        const file = new File([blob], "profile.jpg", { type: "image/jpeg" });
        const fileUrl = URL.createObjectURL(blob);
        
        resolve({ file, fileUrl });
      }, "image/jpeg", 0.9);
    };

    image.onerror = (error) => {
      reject(error);
    };
  });
};

export default CroppedImg;